import React, { useState } from "react";
import { StyledTable } from "atoms/Table";
import { ReactComponent as Dateicon } from "../../../assets/icons/Vector.svg";
import styled from "styled-components";
import { Button, Form, Input, message, Modal, notification, Spin } from "antd";
import Viewmodal from "../../Appraisals/Viewmodal";
import { useHistory } from "react-router-dom";
import { ReactComponent as Tick } from "../../../assets/icons/tick.svg";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import queryKeys from "common/queryKey";
import { useSelector } from "react-redux";
import {
  getMinePerformanceList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { useMutate } from "hooks/useMutate";
import { momentDate } from "utils/Date";
import moment from "moment";
import { CALL_API } from "common/API";
import { CloseCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import axios from "axios";
import { EmployeeInfo } from "../EmployeeInfo";
import user from "../../../assets/employeeinfo.svg";
const ReviewAgree = () => {
  const history = useHistory();
  const { id } = useParams();
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [actionStatus, setActionStatus] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [actionType, setActionType] = useState(""); // "accepted" or "declined"
  const [declineReason, setDeclineReason] = useState("");
  const [loadingButton, setLoadingButton] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalVisibles, setIsModalVisibles] = useState(false);
  const handleCancelModal = () => setIsModalVisibles(false);
  const showModal = () => setIsModalVisibles(true);

  const minePerformanceList = useSelector(getMinePerformanceList);
  const location = useLocation(); // Get the location object

  const appraisalRecord = location.state?.appraisalRecord;

  const selectedEmployee = userList?.find(
    (item) => item?.userid === appraisalRecord?.apraiseemailid
  );

  const handleShowActionModal = (type) => {
    setActionType(type);
    setModalVisible(true);
  };

  const [triedSubmit, setTriedSubmit] = useState(false);

  const handleConfirmAction = async () => {
    setTriedSubmit(true);

    if (actionType === "declined" && !declineReason.trim()) {
      return;
    }

    setLoadingButton(actionType);
    const payload = {
      contractstatus: actionType,
      accepteddeclinedon: new Date().toISOString(),
      reason: actionType === "declined" ? declineReason : "",
      appraiseemailid: appraisalRecord?.apraiseemailid,
      appraisarmailid: appraisalRecord?.apraisercreatedby,
      accepteddeclinedby: appraisalRecord?.apraiseemailid,
    };
    try {
      const response = await CALL_API(
        `appraisal/reviewandaccept/${id}`,
        "patch",
        payload
      );

      if (response?.code === "SUCCESS") {
        setModalVisible(false);
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
          history.push("/performancemanagement");
        }, 2000);
      } else {
        throw new Error("Failed response");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      notification.error({ message: "Failed to update status" });
    } finally {
      setLoadingButton("");
    }
  };

  const transformStrategicObjectives = (data) => {
    return data?.map((item, index) => ({
      key: `strategic-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.straobjorgstartegy || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const transformRolloverResponsibility = (data) => {
    return data?.map((item, index) => ({
      key: `rollover-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.previousappraisalperiod || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const transformUpcomingAppraisal = (data) => {
    return data?.map((item, index) => ({
      key: `upcoming-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.upcomingappraisalperiod || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const strategicObjectivesData = transformStrategicObjectives(
    appraisalRecord?.startegicobjectives || []
  );
  const rolloverResponsibilityData = transformRolloverResponsibility(
    appraisalRecord?.rolloverresponsibility || []
  );
  const upcomingAppraisalData = transformUpcomingAppraisal(
    appraisalRecord?.upcomingappraisalperiod || []
  );

  let filteredData =
    minePerformanceList?.find((item) => item?.contractid?.toString() === id) ||
    [];

  const getColumns = (objectiveTitle) => [
    {
      title: "S.No",
      dataIndex: "Slno",
      key: "Slno",
    },
    {
      title: objectiveTitle,
      dataIndex: "Targetobjectives",
      key: "Targetobjectives",
      className: "wrapped-header",
      width: "30%",
    },
    {
      title: "Expected Outcomes",
      dataIndex: "ExpectedOutcomes",
      key: "ExpectedOutcomes",
      className: "wrapped-header",
      width: "30%",
    },
    {
      title: "Target Date",
      dataIndex: "TargetDate",
      key: "TargetDate",
      render: (text) => (
        <>
          <Dateicon style={{ marginRight: "10px" }} />
          {moment(text).format("DD-MM-YYYY")}
        </>
      ),
    },
    {
      title: "Weightage",
      dataIndex: "Weightage",
      key: "Weightage",
    },
  ];

  // const { addPerformanceContract: addPerformanceContractQuery } = queryKeys;

  let reviewagreedata = filteredData?.upcomingappraisalperiod || [];

  const transformData = (data) => {
    return Object.entries(data).map(([section, items]) => {
      return {
        title: section,
        data: items?.map((item) => ({
          key: `${section}-${item?.sno}`,
          Slno: item?.sno,
          Targetobjectives: item?.targetobjective,
          ExpectedOutcomes: item?.expectedoutcomes,
          TargetDate: item?.targetdate,
        })),
      };
    });
  };

  const transformedData = transformData(reviewagreedata);

  // const { key: addPerformanceContractKey, url: addPerformanceContractUrl } =
  //   addPerformanceContractQuery(true);

  // const { mutate: addPerformanceContract } = useMutate(
  //   addPerformanceContractKey,
  //   addPerformanceContractUrl
  // );

  const userAppraiseId = userList
    ?.find((item) => item?.userid === appraisalRecord?.apraiseemailid)
    .appraisalInformation?.filter(
      (item) => item?.roletype === appraisalRecord?.roletype
    );

  const viewJobDescription = async () => {
    if (
      !userAppraiseId?.[0]?.jobDescriptionId ||
      !userAppraiseId?.[0]?.jobdescriptionFileName
    ) {
      message.warning("User has not created a Job Description.");
      return;
    }
    const token = window.localStorage.getItem("token") || "";
    try {
      setLoader(true);
      const response = await axios.get(
        "https://ozwcklfzkf.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: userAppraiseId?.[0]?.jobDescriptionId,
            filename: userAppraiseId?.[0]?.jobdescriptionFileName,
          },
          headers: { Insytsjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalOpen(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
        setLoader(false);
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div style={{ marginBottom: "100px" }}>
      <Modal
        open={isPdfModalOpen}
        onCancel={() => setIsPdfModalOpen(false)}
        footer={null}
        width={1000}
        centered
        bodyStyle={{ height: "80vh", padding: 0 }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        ) : (
          <p style={{ textAlign: "center", paddingTop: "40%" }}>Loading...</p>
        )}
      </Modal>
      <Spin spinning={loader}>
        <Styleddiv>
          <h6>
            <span
              className="title"
              onClick={() => history.push("/performancemanagement")}
            >
              Performance Management
            </span>
            <span>&gt;</span> Reviewing
          </h6>
          <br />
          <h6>
            {appraisalRecord?.type} Role - Key responsibilities / targets for
            the upcoming appraisal
          </h6>
          <br />
          {strategicObjectivesData?.length > 0 && (
            <div className="table-container">
              <h6>Strategic Objectives</h6>
              <StyledTable
                columns={getColumns(
                  "Strategic Objectives aligned to Organisational Strategy for the upcoming appraisal period"
                )}
                dataSource={strategicObjectivesData}
                pagination={false}
              />
            </div>
          )}
          {rolloverResponsibilityData?.length > 0 && (
            <div className="table-container">
              <div className="d-flex justify-content-between align-items-cente">
                <h6>Rollover Responsibility from Previous Appraisal</h6>
                <p
                  onClick={() => viewJobDescription()}
                  style={{
                    color: "#1890ff",
                    textDecoration: "underline",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                >
                  Job Description
                </p>
              </div>
              <StyledTable
                columns={getColumns(
                  "Objectives that Rolled over from Previous Appraisal Period"
                )}
                dataSource={rolloverResponsibilityData}
                pagination={false}
              />
            </div>
          )}
          {upcomingAppraisalData?.length > 0 && (
            <div className="table-container">
              <div className="d-flex justify-content-between align-items-cente">
                <h6>Objectives from JD for the Upcoming Appraisal Period</h6>
                <p
                  onClick={() => viewJobDescription()}
                  style={{
                    color: "#1890ff",
                    textDecoration: "underline",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                >
                  Job Description
                </p>
              </div>
              <StyledTable
                columns={getColumns(
                  "Target Objectives aligned to Organisational Strategy for the upcoming appraisal period"
                )}
                dataSource={upcomingAppraisalData}
                pagination={false}
              />
            </div>
          )}
          <div className="d-flex align-items-center gap-2 mb-3 btn">
            {filteredData?.agreestatus === "Agree" ? (
              <Button type="primary" onClick={() => history.goBack()}>
                Back
              </Button>
            ) : (
              <>
                <Button
                  loading={loadingButton === "declined"}
                  onClick={() => handleShowActionModal("declined")}
                >
                  Decline
                </Button>
                <Button
                  type="primary"
                  loading={loadingButton === "accepted"}
                  onClick={() => handleShowActionModal("accepted")}
                >
                  Accept
                </Button>
                <Modal
                  open={modalVisible}
                  onCancel={() => {
                    setModalVisible(false);
                    setDeclineReason("");
                    setTriedSubmit(false);
                  }}
                  onOk={handleConfirmAction}
                  okText={actionType === "accepted" ? "Yes, Accept" : "Decline"}
                  cancelText="Cancel"
                  title={
                    actionType === "accepted"
                      ? "Confirm Acceptance"
                      : "Decline Reason"
                  }
                  confirmLoading={loadingButton === actionType}
                >
                  {actionType === "accepted" ? (
                    <p>
                      Are you sure you want to accept and acknowledge this
                      appraisal?
                    </p>
                  ) : (
                    <Form.Item
                      validateStatus={
                        actionType === "declined" &&
                        !declineReason.trim() &&
                        triedSubmit
                          ? "error"
                          : ""
                      }
                      help={
                        actionType === "declined" &&
                        !declineReason.trim() &&
                        triedSubmit
                          ? "Decline reason is required."
                          : ""
                      }
                    >
                      <Input.TextArea
                        rows={4}
                        placeholder="Please provide reason for declining"
                        value={declineReason}
                        onChange={(e) => setDeclineReason(e.target.value)}
                      />
                    </Form.Item>
                  )}
                </Modal>
              </>
            )}
          </div>
        </Styleddiv>
      </Spin>
      <Modal
        open={isModalVisible}
        footer={null}
        closable={false}
        centered
        width={200}
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <div>
          {actionType === "accepted" ? (
            <Tick />
          ) : (
            <CloseCircleOutlined style={{ fontSize: 36, color: "red" }} />
          )}
        </div>
        <p>{actionType === "accepted" ? "Accepted" : "Declined"}</p>
      </Modal>
      <img
        src={user}
        alt="Floating User Icon"
        style={{
          position: "fixed",
          bottom: "10px",
          right: "50px",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          zIndex: 1000,
          cursor: "pointer",
        }}
        onClick={showModal}
      />
      <EmployeeInfo
        isModalVisible={isModalVisibles}
        handleCancelModal={handleCancelModal}
        selectedEmployee={selectedEmployee}
      />
    </div>
  );
};

export default ReviewAgree;

const Styleddiv = styled.div`
  .table-container {
    margin-bottom: 20px;
  }

  .btn {
    justify-content: right;
  }

  .title {
    color: #636980;
    cursor: pointer;
  }
  .wrapped-header {
    white-space: normal !important;
    ${"" /* text-align: center; */}
  }
`;
